// components/copilot/hooks/useThinkingTimers.js
import { useCallback, useEffect, useRef, useState } from "react";

export function useThinkingTimers() {
  const [thinkingVisible, setThinkingVisible] = useState(false);
  const thinkingTimerRef = useRef(null);

  const [sessionLoadingVisible, setSessionLoadingVisible] = useState(false);
  const sessionLoadingTimerRef = useRef(null);

  const startThinkingTimer = useCallback(() => {
    setThinkingVisible(false);
    if (thinkingTimerRef.current) clearTimeout(thinkingTimerRef.current);
    thinkingTimerRef.current = setTimeout(() => {
      setThinkingVisible(true);
      thinkingTimerRef.current = null;
    }, 650);
  }, []);

  const startSessionLoadingTimer = useCallback(() => {
    setSessionLoadingVisible(false);
    if (sessionLoadingTimerRef.current) clearTimeout(sessionLoadingTimerRef.current);
    sessionLoadingTimerRef.current = setTimeout(() => {
      setSessionLoadingVisible(true);
      sessionLoadingTimerRef.current = null;
    }, 250);
  }, []);

  const stopThinking = useCallback(() => {
    setThinkingVisible(false);
    if (thinkingTimerRef.current) {
      clearTimeout(thinkingTimerRef.current);
      thinkingTimerRef.current = null;
    }
  }, []);

  const stopSessionLoading = useCallback(() => {
    setSessionLoadingVisible(false);
    if (sessionLoadingTimerRef.current) {
      clearTimeout(sessionLoadingTimerRef.current);
      sessionLoadingTimerRef.current = null;
    }
  }, []);

  const resetAllTimers = useCallback(() => {
    stopThinking();
    stopSessionLoading();
  }, [stopThinking, stopSessionLoading]);

  // cleanup on unmount
  useEffect(() => {
    return () => resetAllTimers();
  }, [resetAllTimers]);

  return {
    thinkingVisible,
    sessionLoadingVisible,
    startThinkingTimer,
    startSessionLoadingTimer,
    stopThinking,
    stopSessionLoading,
    resetAllTimers,
  };
}
